import { stripIgnoredCharacters } from 'graphql';
import { compose } from 'utils';

import { operationNameTraceUrl } from './operation-name-tracer';

// Chrome starts truncating urls at around 7500 so
// we put a limit on it. Sanity supports up to 11KB
const MAX_QUERY_LENGTH = 7500;

function compressQuery(parsedBody: Record<string, string>): Record<string, string> {
  const query = stripIgnoredCharacters(parsedBody.query || '');

  return { ...parsedBody, query };
}

function stringifyVariables(parsedBody: Record<string, string | object>): Record<string, string> {
  const variables = JSON.stringify(parsedBody.variables);

  return { ...parsedBody, variables };
}

const transformBody = compose(compressQuery, stringifyVariables, JSON.parse);

export async function sanityFetch(url: string, config: RequestInit): Promise<Response> {
  const { body } = config;

  const compressedBody = transformBody(body as string);

  const compressedBodyString = JSON.stringify(compressedBody);

  const useGet = encodeURIComponent(compressedBodyString).length <= MAX_QUERY_LENGTH;

  let requestUrl = new URL(url);

  const newRequestConfig: RequestInit = {
    ...config,
    method: useGet ? 'GET' : 'POST',
  };

  delete newRequestConfig.body;

  if (useGet) {
    Object.entries(compressedBody).forEach(([key, value]: [string, string]) => {
      requestUrl.searchParams.append(
        key,
        typeof value !== 'string' ? JSON.stringify(value) : value
      );
    });
  } else {
    requestUrl = operationNameTraceUrl(requestUrl, compressedBodyString);
    newRequestConfig.body = compressedBodyString;
  }

  return fetch(requestUrl.href, newRequestConfig);
}
